
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[id]/on-demand",
      function () {
        return require("private-next-pages/events/[id]/on-demand.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[id]/on-demand"])
      });
    }
  